import { CLOUDINARY_CLOUD_NAME, CLOUDINARY_DOMAIN } from '../../config';
import ImagesUrlService from './images-url-service';
import VideosUrlService from './videos-url-service';

export const imagesUrlService = new ImagesUrlService(CLOUDINARY_DOMAIN, CLOUDINARY_CLOUD_NAME);
export const videosUrlService = new VideosUrlService(CLOUDINARY_DOMAIN, CLOUDINARY_CLOUD_NAME);
